import { jsx } from "react/jsx-runtime";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { validateTidalLicense } from "../../base/index.js";
function AdminPanelSettings(props) {
  return /* @__PURE__ */ jsx(
    AdminPanelSettingsIcon,
    {
      "data-testid": "AdminPanelSettings",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AdminPanelSettings",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
AdminPanelSettings.tidalIconMeta = {
  categories: "miscellaneous",
  name: "AdminPanelSettings"
};
validateTidalLicense();
export {
  AdminPanelSettings
};
//# sourceMappingURL=AdminPanelSettings.js.map
